import type { GoalStateEnum } from "web_myplann/Infrastructure/Api/Api";

export const GoalsKeys = {
	all: ["goals"] as const,
	list: (filterStates?: GoalStateEnum[]) =>
		[...GoalsKeys.all, "list", filterStates] as const,
	detail: (id: number) => [...GoalsKeys.all, "detail", id] as const,
	detailPortfolios: () => [...GoalsKeys.all, "detailPortfolios"] as const,
};
